var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 11,
    r: 10,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53539 12.77C8.53539 12.242 8.69139 11.738 9.00339 11.258C9.32739 10.778 9.67539 10.394 10.0474 10.106C10.4194 9.806 10.7614 9.458 11.0734 9.062C11.3974 8.666 11.5594 8.27 11.5594 7.874C11.5594 7.454 11.4154 7.13 11.1274 6.902C10.8394 6.674 10.4374 6.56 9.92139 6.56C8.91339 6.56 8.19939 7.094 7.77939 8.162L5.65539 6.938C6.01539 6.05 6.58539 5.366 7.36539 4.886C8.15739 4.394 9.03939 4.148 10.0114 4.148C11.1034 4.148 12.0454 4.466 12.8374 5.102C13.6414 5.726 14.0434 6.59 14.0434 7.694C14.0434 8.198 13.9354 8.666 13.7194 9.098C13.5154 9.53 13.2634 9.902 12.9634 10.214C12.6754 10.514 12.3814 10.802 12.0814 11.078C11.7934 11.342 11.5414 11.618 11.3254 11.906C11.1214 12.194 11.0194 12.482 11.0194 12.77H8.53539ZM10.8574 16.784C10.5574 17.084 10.1974 17.234 9.77739 17.234C9.35739 17.234 8.99739 17.084 8.69739 16.784C8.39739 16.484 8.24739 16.124 8.24739 15.704C8.24739 15.284 8.39739 14.924 8.69739 14.624C8.99739 14.324 9.35739 14.174 9.77739 14.174C10.1974 14.174 10.5574 14.324 10.8574 14.624C11.1574 14.924 11.3074 15.284 11.3074 15.704C11.3074 16.124 11.1574 16.484 10.8574 16.784Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.9d1159c02d9a4b48e4315c071a5071a3.svg";
export { ForwardRef as ReactComponent };